import React from "react";
import { MdOutlineCancel } from "react-icons/md";
import { filterProfilePicture } from "../../helper";
const TeacherDetailPopup = ({ teacherDetail, onClose }) => {
  return (
    <div className="">
      <div className="d-flex justify-content-end ">
        <MdOutlineCancel size={20} onClick={onClose} />
      </div>

      <div className="mt-2">
        <img
          src={
            filterProfilePicture(teacherDetail?.teacherMedia)
              ? `${filterProfilePicture(teacherDetail?.teacherMedia)}`
              : require("../../assets/images/avatar.jpg")
          }
          className="rounded-circle border border-3 shadow border-light"
          style={{ height: "50px", width: "50px" }}
          alt=""
        />
        <b>
          <span className="ps-2">{teacherDetail?.fullName}</span>
        </b>
      </div>
      <hr />

      {/* <div className="mt-2">
        <h6>Teaching Boards</h6>
        {teacherDetail?.teacherBoards?.length ? (
          <>
            <ul>
              {teacherDetail?.teacherBoards?.map((item, index) => {
                return <li key={index}>{item?.boardName}</li>;
              })}
            </ul>
          </>
        ) : (
          "N/A"
        )}
        <hr />
      </div> */}

      <div className="mt-2">
        <h6>Teaching Areas</h6>
        {teacherDetail?.teacherAreas?.length ? (
          <>
            <ul>
              {teacherDetail?.teacherAreas?.map((item, index) => {
                return <li key={index}>{item?.subAreaName}</li>;
              })}
            </ul>
          </>
        ) : (
          "N/A"
        )}
        <hr />
      </div>
      <div className="mt-2">
        <h6>Teacher Academic Experience</h6>
        {teacherDetail?.teacherAcademicExperiences?.length ? (
          <>
            <ul>
              {teacherDetail?.teacherAcademicExperiences?.map((item, index) => {
                return <li key={index}>{item?.organization}</li>;
              })}
            </ul>
          </>
        ) : (
          "N/A"
        )}
        <hr />
      </div>
      <div className="mt-2">
        <h6>Teacher Corporate Experiences</h6>
        {teacherDetail?.teacherCorporateExperiences?.length ? (
          <>
            <ul>
              {teacherDetail?.teacherCorporateExperiences?.map(
                (item, index) => {
                  return <li key={index}>{item?.organization}</li>;
                }
              )}
            </ul>
          </>
        ) : (
          "N/A"
        )}
        <hr />
      </div>
      <div className="mt-2">
        <h6>Teacher Courses</h6>

        <div className="d-flex flex-wrap">
          {teacherDetail?.courses?.length
            ? teacherDetail?.courses?.map((cur, i) =>
                i === teacherDetail?.courses?.length - 1 ? (
                  <span key={i}>{cur?.courseSubjectName}</span>
                ) : (
                  <span className="me-2" key={i}>
                    {cur?.courseSubjectName},
                  </span>
                )
              )
            : "N/A"}
        </div>
        {/* {teacherDetail?.courses?.length ? (
          <>
            <ul>
            <div className="d-flex flex-wrap">
              {teacherDetail?.courses?.map(
                (item, index) => {
                  return <li key={index}>{item?.courseSubjectName}</li>;
                }
              )}
              </div>
            </ul>
          </>
        ) : (
          "N/A"
        )} */}
        <hr />
      </div>
    </div>
  );
};

export default TeacherDetailPopup;
